{
  "menu": "Menú d'ajustos",
  "cerca": "Cerca als ajustos…",
  "senseResultats": "Cap ajust coincideix",
  "inici": "Tots els ajustos",
  "grups": {
    "organitzacio": "Organització",
    "persones": "Persones i permisos",
    "avisos": "Avisos",
    "documentacio": "Documentació",
    "sistema": "Sistema"
  },
  "canvis": {
    "pendents_one": "{{count}} canvi sense desar",
    "pendents_other": "{{count}} canvis sense desar",
    "pendentsA_one": "{{count}} canvi sense desar a «{{nom}}»",
    "pendentsA_other": "{{count}} canvis sense desar a «{{nom}}»",
    "descarta": "Descarta",
    "desa": "Desa",
    "desant": "Desant…",
    "sortirTitol": "Tens canvis sense desar",
    "sortirText": "Si continues, es perdran els canvis que no has desat.",
    "sortirDescarta": "Descarta els canvis",
    "sortirContinua": "Continua editant"
  },
  "confirma": {
    "cancella": "Cancel·la"
  },
  "estructura": {
    "cerca": "Cerca departament, àrea o servei…",
    "toda": "Tota l'organització",
    "departament": "Departament",
    "area": "Àrea",
    "servei": "Servei",
    "inclouFills": "Inclou totes les seves àrees i serveis",
    "inclouServeis": "Inclou tots els seus serveis",
    "senseResultats": "Res no coincideix amb «{{q}}»",
    "inactiu": "Inactiu"
  },
  "mostraInactius": "Mostra inactius",
  "nou": "Nou",
  "tanca": "Tanca"
}
